import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";
import Icon2 from "../assets/img/Shape.svg";

const ContactForm = () => {
  const form = useRef();
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSending(true);

    // FormData ko object me convert
    const formData = new FormData(form.current);
    const jsonData = Object.fromEntries(formData.entries());
    console.log("Form Data sending to PHP:", jsonData);

    try {
      // 1. EmailJS se bhejna
      await emailjs.sendForm(
        "service_r1t9oq8",
        "template_3rqc8ok",
        form.current,
        "o0-qZnllB8LkS2pa0"
      );

      console.log("Email sent successfully");

      // 2. PHP ko bhejna
      const response = await fetch("https://workdayz.in/home_contact_form.php", {
        method: "POST",
        body: JSON.stringify(jsonData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      console.log("PHP Response:", result);

      if (result.success) {
        navigate("/thank-you");
      } else {
        alert("Database save failed: " + result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <div className="row">
        <div className="col-sm-6">
          <label htmlFor="fname">First Name</label><br />
          <input type="text" id="fname" name="fname" placeholder="First Name" required />
        </div>
        <div className="col-sm-6">
          <label htmlFor="lname">Last Name</label><br />
          <input type="text" id="lname" name="lname" placeholder="Last Name" required />
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <label htmlFor="email">Email</label><br />
          <input type="email" id="email" name="email" placeholder="Enter email" required />
        </div>
        <div className="col-sm-6">
          <label htmlFor="phone">Phone</label><br />
          <input type="text" id="phone" name="phone" placeholder="Enter phone number" required />
        </div>
      </div>

      <label htmlFor="message">Message</label><br />
      <textarea name="message" placeholder="Write your message" required></textarea>
      <br />

      <div data-animate="bottom" className="animeslide-desc submit_btn">
        <button type="submit" disabled={isSending}>
          {isSending ? (
            <>
              <span className="spinner"></span>
              <span>Sending...</span>
            </>
          ) : (
            <>
              <img src={Icon2} alt="" />
              <span>Submit</span>
            </>
          )}
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
